// extracted by mini-css-extract-plugin
module.exports = {"container":"_3187594","textContainer":"_2533aaf","title":"_fc4dcee","body":"_710f23f"};